import { APIServiceImpl } from "./api-service-impl";
export { APIErrorCode, APIError } from "./api-service-base";
export const apiService = new APIServiceImpl();
